import { authenticatedRestClient } from 'helpers/restclient';

export default class CheckoutService {
	static instance = new CheckoutService();

	_endpoints = {
		getCheckoutItems: `/api/v4/checkout`,
		getCheckoutServices: (transactionId) => `/api/v4/checkout/${transactionId}/items`,
		getCheckoutPreview: `/api/v4/checkout/review`,
		submitCheckout: `/api/v4/transactions/checkout`,
		updateCheckout: `/api/v4/transactions/checkout_item`,
		updateDropoffAddress: (transactionId) => `/api/transactions/${transactionId}/dropoff_address`,
	};

	constructor() {
		this.restClient = authenticatedRestClient;
	}

	getCheckoutItems = (cancelToken) => {
		const endpoint = this._endpoints.getCheckoutItems;
		return this.restClient.get(endpoint, {}, {}, cancelToken);
	};

	getCheckoutServices = ({ transactionId }) => {
		const endpoint = this._endpoints.getCheckoutServices(transactionId);
		return this.restClient.get(endpoint, {});
	};

	getCheckoutPreview = (cancelToken) => {
		const endpoint = this._endpoints.getCheckoutPreview;
		return this.restClient.get(endpoint, {}, {}, cancelToken);
	};

	submitCheckout = (transactionIds, cancelToken) => {
		const endpoint = this._endpoints.submitCheckout;
		return this.restClient.put(endpoint, { transaction_ids: transactionIds, from_mobile: 0 }, {}, cancelToken);
	};

	updateCheckoutItem = (transactionId, changes, cancelToken) => {
		const endpoint = this._endpoints.updateCheckout;
		return this.restClient.patch(endpoint, { id: transactionId, ...changes }, {}, cancelToken);
	};

	updateDropoffAddress = ({ transactionId, dropoffAddressId }, cancelToken) => {
		const endpoint = this._endpoints.updateDropoffAddress(transactionId);
		return this.restClient.put(endpoint, { dropoff_address_id: dropoffAddressId }, {}, cancelToken);
	};
}
